import React, { useContext } from 'react';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { useNavigate } from 'react-router';
import './style.scss';
import successPic from '../../../images/success-icon-2.png';

const SuccessPopupWithBenefits = () => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);
  const navigate = useNavigate();

  const onClick = (routPath) => {
    navigate(routPath);
    closePopup();
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Welcome to terminal pro!')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Your account has been created successfully.')}</p>
        {/* <img alt="success-icon" className="success-icon" src={successPic} /> */}
        <div className="icon-done-box">
          <i className="global-icon icon-circle-done done" />
        </div>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => onClick('/prematch/all/')}
        >
          {t('PLACE A BET')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={() => onClick('/')}
        >
          {t('GO TO HOME')}
        </button>
      </div>

    </div>
  );
};

export default SuccessPopupWithBenefits;
